module.exports = __webpack_public_path__ + "media/images/landing/bg/case-johany/intro-d71467296cc6ed8254e01641a662ba49.jpg";